import { round } from 'lodash'
import {
	photoGridSubCategories,
	quoteDigitalSubCategories,
} from 'src/utils/quoteGridUtils/createQuoteUtil'

function getQuoteCategories(quoteType) {
	switch (quoteType) {
		case 'photoGrid':
			return photoGridSubCategories
		case 'quoteDigital':
			return quoteDigitalSubCategories
		default:
			return photoGridSubCategories
	}
}

function photoGridTotalsSummary(quoteDetails, quoteInfo, recapInfo) {
	// create a totals object for the quote
	const totalsObject = {
		id: null,
		name: null,
		categoryTotals: [],
		franceCategoryTotals: [],
		internationalCategoryTotals: [],
		totals: {},
		franceTotals: {},
		internationalTotals: {},
		discount: null,
		totalsWithTax: {},
		subtotalsWithAccSections: [],
		subtotalsWithQuoteType: [],
	}
	// if quote doesn't exist it sends back the empty totalsObject
	if (!quoteDetails) {
		return totalsObject
	}
	// set name and id of quote on totals object
	totalsObject.id = quoteDetails.id
	totalsObject.name = quoteDetails.name
	// initialize the quote totals object
	const totals = getTotalTemplateObject()
	const franceTotals = getTotalTemplateObject()
	const internationalTotals = getTotalTemplateObject()
	// get the category totals template array for all categories
	const categoryTotalsArray = getCategoryTotalsTemplateArray(
		quoteDetails,
		quoteInfo,
		recapInfo,
		null
	)
	const franceCategoryTotalsArray = getCategoryTotalsTemplateArray(
		quoteDetails,
		quoteInfo,
		recapInfo,
		'f'
	)
	const internationalCategoryTotalsArray = getCategoryTotalsTemplateArray(
		quoteDetails,
		quoteInfo,
		recapInfo,
		'i'
	)
	const allTotalsObject = {
		totals,
		franceTotals,
		internationalTotals,
		categoryTotalsArray,
		franceCategoryTotalsArray,
		internationalCategoryTotalsArray,
	}
	// get all the category total rows from quote Info, so at this point we have the latest budget total information
	// also initialize the provisionalTotal and actualTotal to be 0 for all these categories.
	let categoryTotalRows = quoteInfo
		.filter((row) => row.costLineType === 'subCategoryTotal')
		.map((totalRow) => {
			const localTotalRow = { ...totalRow }
			localTotalRow.provisionalTotal = 0
			localTotalRow.actualTotal = 0
			return localTotalRow
		})

	// if grid2 / recapInfo has been populated, we might have differet provisional and actual total information
	if (recapInfo?.length) {
		// get all the category total rows in recap info (essentially all categories that have totals)
		const recapInfoCategoryTotalRows = recapInfo.filter(
			(row) => row.costLineType === 'subCategoryTotal'
		)
		// Sets the the category totals for provisional and actual we got from above to the categoryTotalRows
		categoryTotalRows = categoryTotalRows.map((totalRow) => {
			const localTotalRow = { ...totalRow }
			// Finds the index in recapInfoCategory Totals where the current category total name matches with recapCategoryTotal
			const recapInfoCategoryTotalRowIndex =
				recapInfoCategoryTotalRows.findIndex(
					(recapInfoTotalRow) =>
						totalRow.subCategory === recapInfoTotalRow.subCategory
				)
			// If index was found we set the current categories provisional and actual total to that of recapInfo
			if (recapInfoCategoryTotalRowIndex >= 0) {
				const { provisionalTotal, actualTotal } =
					recapInfoCategoryTotalRows[recapInfoCategoryTotalRowIndex]
				localTotalRow.provisionalTotal = provisionalTotal
				localTotalRow.actualTotal = actualTotal
			}
			return localTotalRow
		})
	}

	// loop over the categoryTotalRows -
	// 1. update the categoryTotalsArray (templateArray) with correct total values
	// 2. update the totalsObjects (categoryTotalsArray, totals, franceTotals, internationalTotals) of the quote with the correct totals

	let finalAllTotalsObject = categoryTotalRows.reduce(
		(allTotalsObject, totalRow, index) => {
			// allTotalsObject is defined above with all relevant details
			// Finds the index of the category index where

			const categoryTotalsArrayIndex =
				allTotalsObject.categoryTotalsArray.findIndex(
					(row) => row.category === totalRow.subCategory
				)
			if (!totalRow.isInternational) {
				// if it is a france category
				const franceCategoryTotalsArrayIndex =
					allTotalsObject.franceCategoryTotalsArray.findIndex(
						(row) => row.category === totalRow.subCategory
					)
				// If the catergoryTotalsArray has the index for the totals we save the totals value in allTotalsObject
				// provisional & actualTotal are set to 0 if not present
				if (categoryTotalsArrayIndex >= 0) {
					allTotalsObject.categoryTotalsArray[
						categoryTotalsArrayIndex
					].budgetTotal = round(totalRow.total, 2)
					allTotalsObject.categoryTotalsArray[
						categoryTotalsArrayIndex
					].provisionalTotal = totalRow.provisionalTotal
					allTotalsObject.categoryTotalsArray[
						categoryTotalsArrayIndex
					].actualTotal = totalRow.actualTotal
				}
				if (franceCategoryTotalsArrayIndex >= 0) {
					allTotalsObject.franceCategoryTotalsArray[
						franceCategoryTotalsArrayIndex
					].budgetTotal = totalRow.total
					allTotalsObject.franceCategoryTotalsArray[
						franceCategoryTotalsArrayIndex
					].provisionalTotal = totalRow.provisionalTotal
					allTotalsObject.franceCategoryTotalsArray[
						franceCategoryTotalsArrayIndex
					].actualTotal = totalRow.actualTotal
				}
			} else {
				// if it is an international category
				const internationalCategoryTotalsArrayIndex =
					allTotalsObject.internationalCategoryTotalsArray.findIndex(
						(row) => row.subCategory === totalRow.subCategory
					)
				// for the normal totals array, add the international totals to the existing france totals
				if (categoryTotalsArrayIndex >= 0) {
					allTotalsObject.categoryTotalsArray[
						categoryTotalsArrayIndex
					].budgetTotal += round(totalRow.total, 2)
					allTotalsObject.categoryTotalsArray[
						categoryTotalsArrayIndex
					].provisionalTotal += round(totalRow.provisionalTotal, 2)
					allTotalsObject.categoryTotalsArray[
						categoryTotalsArrayIndex
					].actualTotal += round(totalRow.actualTotal, 2)
				}
				if (internationalCategoryTotalsArrayIndex >= 0) {
					allTotalsObject.internationalCategoryTotalsArray[
						internationalCategoryTotalsArrayIndex
					].budgetTotal = round(totalRow.total, 2)

					allTotalsObject.internationalCategoryTotalsArray[
						internationalCategoryTotalsArrayIndex
					].provisionalTotal = round(totalRow.provisionalTotal, 2)

					allTotalsObject.internationalCategoryTotalsArray[
						internationalCategoryTotalsArrayIndex
					].actualTotal = round(totalRow.actualTotal, 2)
				}
			}

			if (totalRow.total) {
				allTotalsObject.totals.budgetSubTotal += totalRow.total
				allTotalsObject.totals.budgetGrandTotal += totalRow.total
				// actual and provisional grand total are always the same as bugetGrandTotal
				allTotalsObject.totals.actualGrandTotal += totalRow.total
				allTotalsObject.totals.provisionalGrandTotal += totalRow.total
				if (totalRow.isInternational) {
					allTotalsObject.internationalTotals.budgetSubTotal +=
						totalRow.total
					allTotalsObject.internationalTotals.budgetGrandTotal +=
						totalRow.total
					// actual and provisional grand total are always the same as bugetGrandTotal
					allTotalsObject.internationalTotals.actualGrandTotal +=
						totalRow.total
					allTotalsObject.internationalTotals.provisionalGrandTotal +=
						totalRow.total
				} else {
					allTotalsObject.franceTotals.budgetSubTotal +=
						totalRow.total
					allTotalsObject.franceTotals.budgetGrandTotal +=
						totalRow.total
					// actual and provisional grand total are always the same as bugetGrandTotal
					allTotalsObject.franceTotals.actualGrandTotal +=
						totalRow.total
					allTotalsObject.franceTotals.provisionalGrandTotal +=
						totalRow.total
				}
			}
			if (totalRow.actualTotal) {
				allTotalsObject.totals.actualSubTotal += totalRow.actualTotal
				if (totalRow.isInternational) {
					allTotalsObject.internationalTotals.actualSubTotal +=
						totalRow.actualTotal
				} else {
					allTotalsObject.franceTotals.actualSubTotal +=
						totalRow.actualTotal
				}
			}
			if (totalRow.provisionalTotal) {
				allTotalsObject.totals.provisionalSubTotal +=
					totalRow.provisionalTotal
				if (totalRow.isInternational) {
					allTotalsObject.internationalTotals.provisionalSubTotal +=
						totalRow.provisionalTotal
				} else {
					allTotalsObject.franceTotals.provisionalSubTotal +=
						totalRow.provisionalTotal
				}
			}
			if (totalRow.totalMargin) {
				allTotalsObject.totals.budgetMargin += totalRow.totalMargin
				allTotalsObject.totals.budgetGrandTotal += totalRow.totalMargin
				// add the budget margin to actual grand total only when actual grand total exists
				if (allTotalsObject.totals.actualGrandTotal)
					allTotalsObject.totals.actualGrandTotal +=
						totalRow.totalMargin
				// add the budget margin to provisional grand total only when provisional grand total exists
				if (allTotalsObject.totals.provisionalGrandTotal)
					allTotalsObject.totals.provisionalGrandTotal +=
						totalRow.totalMargin
				if (totalRow.isInternational) {
					allTotalsObject.internationalTotals.budgetMargin +=
						totalRow.totalMargin
					allTotalsObject.internationalTotals.budgetGrandTotal +=
						totalRow.totalMargin
					// add the budget margin to actual grand total only when actual grand total exists
					if (allTotalsObject.internationalTotals.actualGrandTotal)
						allTotalsObject.internationalTotals.actualGrandTotal +=
							totalRow.totalMargin
					// add the budget margin to provisional grand total only when provisional grand total exists
					if (
						allTotalsObject.internationalTotals
							.provisionalGrandTotal
					)
						allTotalsObject.internationalTotals.provisionalGrandTotal +=
							totalRow.totalMargin
				} else {
					allTotalsObject.franceTotals.budgetMargin +=
						totalRow.totalMargin
					allTotalsObject.franceTotals.budgetGrandTotal +=
						totalRow.totalMargin
					// add the budget margin to actual grand total only when actual grand total exists
					if (allTotalsObject.franceTotals.actualGrandTotal)
						allTotalsObject.franceTotals.actualGrandTotal +=
							totalRow.totalMargin
					// add the budget margin to provisional grand total only when provisional grand total exists
					if (allTotalsObject.franceTotals.provisionalGrandTotal)
						allTotalsObject.franceTotals.provisionalGrandTotal +=
							totalRow.totalMargin
				}
			}
			return allTotalsObject
		},
		allTotalsObject
	)

	finalAllTotalsObject = quoteInfo.reduce((allTotalsObject, row, index) => {
		if (
			row.total &&
			row.costLineType === 'costLine' &&
			(row.margin || row.overhead)
		) {
			if (row.margin)
				allTotalsObject.totals.budgetSeperateMargin += row.margin
			if (row.overhead)
				allTotalsObject.totals.budgetSeperateOverhead += row.overhead
		}
		return allTotalsObject
	}, finalAllTotalsObject)

	// update the category totals array
	totalsObject.categoryTotals = finalAllTotalsObject.categoryTotalsArray
	totalsObject.franceCategoryTotals =
		finalAllTotalsObject.franceCategoryTotalsArray
	totalsObject.internationalCategoryTotals =
		finalAllTotalsObject.internationalCategoryTotalsArray
	delete finalAllTotalsObject.categoryTotalsArray
	delete finalAllTotalsObject.franceCategoryTotalsArray
	delete finalAllTotalsObject.internationalCategoryTotalsArray

	// calculate all margins in the totalsObjects and then round of all totals to two decimal places
	for (const key in finalAllTotalsObject) {
		finalAllTotalsObject[key] = calculateMarginsAndReturnUpdatedTotals(
			finalAllTotalsObject[key]
		)
		for (const totalKey in finalAllTotalsObject[key]) {
			finalAllTotalsObject[key][totalKey] = round(
				finalAllTotalsObject[key][totalKey],
				2
			)
		}
	}

	// assign the final totals to the actual totalsObject
	totalsObject.totals = finalAllTotalsObject.totals
	totalsObject.franceTotals = finalAllTotalsObject.franceTotals
	totalsObject.internationalTotals = finalAllTotalsObject.internationalTotals

	if (quoteDetails.discount?.totalDiscount) {
		// get the discount object
		const quoteDiscountObject = { ...quoteDetails.discount }
		const discount = getDiscountTemplateObject()

		// total after discount and discount is the same in cases
		discount.totalAfterDiscount = round(
			quoteDiscountObject.totalAfterDiscount,
			2
		)
		discount.totalDiscount = round(
			totalsObject.totals.budgetGrandTotal - discount.totalAfterDiscount,
			2
		)
		// budget discount values
		discount.budgetTotalDiscountOnMargin = round(
			totalsObject.totals.budgetMargin - discount.totalDiscount,
			2
		)
		discount.budgetTotalDiscountOnMarginPercentage = round(
			(discount.budgetTotalDiscountOnMargin /
				discount.totalAfterDiscount) *
				100,
			2
		)
		discount.budgetTotalDiscountPercentage = round(
			totalsObject.totals.budgetMarginPercentage -
				discount.budgetTotalDiscountOnMarginPercentage,
			2
		)

		// provisional discount values
		discount.provisionalTotalDiscountOnMargin = round(
			totalsObject.totals.provisionalMargin - discount.totalDiscount,
			2
		)
		discount.provisionalTotalDiscountOnMarginPercentage = round(
			(discount.provisionalTotalDiscountOnMargin /
				discount.totalAfterDiscount) *
				100,
			2
		)
		discount.provisionalTotalDiscountPercentage = round(
			totalsObject.totals.provisionalMarginPercentage -
				discount.provisionalTotalDiscountOnMarginPercentage,
			2
		)

		// actual discount values
		discount.actualTotalDiscountOnMargin = round(
			totalsObject.totals.actualMargin - discount.totalDiscount,
			2
		)
		discount.actualTotalDiscountOnMarginPercentage = round(
			(discount.actualTotalDiscountOnMargin /
				discount.totalAfterDiscount) *
				100,
			2
		)
		discount.actualTotalDiscountPercentage = round(
			totalsObject.totals.actualMarginPercentage -
				discount.actualTotalDiscountOnMarginPercentage,
			2
		)

		totalsObject.discount = discount
	} else {
		const discount = getDiscountTemplateObject()
		// total after discount and discount is the same in cases
		discount.totalAfterDiscount = totalsObject.totals.budgetGrandTotal
		totalsObject.discount = discount
	}

	const vatRates = [0.2]
	const totalTaxAmount =
		totalsObject?.discount?.totalAfterDiscount * vatRates[0]

	const rateObject = {
		taxRate: 0.2,
		taxPercentage: 20,
		taxAmount: totalTaxAmount,
		taxableAmount: totalsObject?.discount?.totalAfterDiscount,
	}

	const totalsWithTaxObject = {
		subTotal: totalsObject?.discount?.totalAfterDiscount,
		taxAmount: totalTaxAmount,
		taxDetails: [rateObject],
	}
	totalsObject.totalsWithTax = totalsWithTaxObject

	const sectionOptions = [
		'servicesProvided20',
		'publishingRights10',
		'masterRights20',
		'billOfRights10',
		'billOfRights20',
		'rightMusic',
		'copyRightAndReproduction',
		'servicesProvided10',
		'synchroTradingService',
		'tradingService',
		'servicesProvided10',
		'synchroTradingService',
		'tradingService',
	]
	let subtotalPerSectionArray = []

	// //  ! Remove when we add sections to costlines in this quote type
	// subtotalPerSectionArray = [
	//   {
	//     type: quoteDetails?.quoteType,
	//     amount: totalsObject?.discount?.totalAfterDiscount,
	//   },
	// ]

	// ! Will change once these quote types have sections
	// For now null, so that we can display conditionally non null values
	subtotalPerSectionArray = null
	totalsObject.subtotalsWithAccSections = subtotalPerSectionArray

	const subtotalPerQuoteTypeArray = [
		{
			type: quoteDetails?.quoteType,
			amount: totalsObject?.discount?.totalAfterDiscount,
		},
	]

	totalsObject.subtotalsWithQuoteType = subtotalPerQuoteTypeArray

	return totalsObject
}

function calculateMarginsAndReturnUpdatedTotals(quoteTotals) {
	if (quoteTotals.budgetGrandTotal) {
		quoteTotals.budgetMarginPercentage = round(
			(quoteTotals.budgetMargin / quoteTotals.budgetGrandTotal) * 100,
			2
		)
		quoteTotals.budgetSeperateMarginPercentage = round(
			(quoteTotals.budgetSeperateMargin / quoteTotals.budgetGrandTotal) *
				100,
			2
		)
		quoteTotals.budgetSeperateOverheadPercentage = round(
			(quoteTotals.budgetSeperateOverhead /
				quoteTotals.budgetGrandTotal) *
				100,
			2
		)
	}

	const diffBetweenBudgetAndActual =
		quoteTotals.budgetSubTotal - quoteTotals.actualSubTotal
	quoteTotals.actualMargin = round(
		quoteTotals.budgetMargin + diffBetweenBudgetAndActual,
		2
	)
	if (quoteTotals.budgetGrandTotal)
		quoteTotals.actualMarginPercentage = round(
			(quoteTotals.actualMargin / quoteTotals.budgetGrandTotal) * 100,
			2
		)
	const diffBetweenBudgetAndProvisional =
		quoteTotals.budgetSubTotal - quoteTotals.provisionalSubTotal
	quoteTotals.provisionalMargin = round(
		quoteTotals.budgetMargin + diffBetweenBudgetAndProvisional,
		2
	)
	if (quoteTotals.budgetGrandTotal)
		quoteTotals.provisionalMarginPercentage = round(
			(quoteTotals.provisionalMargin / quoteTotals.budgetGrandTotal) *
				100,
			2
		)
	return quoteTotals
}

function getDiscountTemplateObject() {
	return {
		totalAfterDiscount: 0,
		totalDiscount: 0,
		budgetTotalDiscountOnMargin: 0,
		budgetTotalDiscountOnMarginPercentage: 0,
		budgetTotalDiscountPercentage: 0,
		provisionalTotalDiscountOnMargin: 0,
		provisionalTotalDiscountOnMarginPercentage: 0,
		provisionalTotalDiscountPercentage: 0,
		actualTotalDiscountOnMargin: 0,
		actualTotalDiscountOnMarginPercentage: 0,
		actualTotalDiscountPercentage: 0,
	}
}

function getTotalTemplateObject() {
	return {
		budgetSubTotal: 0,
		budgetGrandTotal: 0,
		budgetMargin: 0,
		budgetMarginPercentage: 0,
		budgetSeperateMargin: 0,
		budgetSeperateMarginPercentage: 0,
		budgetSeperateOverhead: 0,
		budgetSeperateOverheadPercentage: 0,
		provisionalSubTotal: 0,
		provisionalGrandTotal: 0,
		provisionalMargin: 0,
		provisionalMarginPercentage: 0,
		actualSubTotal: 0,
		actualGrandTotal: 0,
		actualMargin: 0,
		actualMarginPercentage: 0,
	}
}

function getCategoryTotalsTemplateArray(
	quoteDetails,
	quoteInfo,
	recapInfo,
	franceOrInternational
) {
	let categories = getQuoteCategories(quoteDetails.quoteType)
	if (franceOrInternational) {
		if (franceOrInternational === 'i') {
			// get only the international categories when explicit asked for international categories
			categories = categories.filter((c) => c.isInternational)
		} else {
			// keep only the france categories as they represent all the unique categories
			categories = categories.filter((c) => !c.isInternational)
		}
	} else {
		// get only the france categories as they represent all the unique categories
		categories = categories.filter((c) => !c.isInternational)
	}
	// the name is normalized by replacing ' - EXE' with '' in the map below to make sure all the categories have the same name

	return categories.map((c) => {
		return {
			isInternational: franceOrInternational ? c.isInternational : null,
			categoryPrefix: c.subCategoryPrefix,
			categoryRoman: c.subCategoryPrefix.substring(
				0,
				c.subCategoryPrefix.length - 1
			),
			categoryId: c.subCategoryId,
			category: c.subCategory,
			category_fr: c.subCategory_fr,
			budgetTotal: 0,
			provisionalTotal: 0,
			actualTotal: 0,
		}
	})
}

export { photoGridTotalsSummary }
